import { styled } from '../../../theme/stitches.config';

export const StyledLabel = styled('span', {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 12,
});
